var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIconOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.97156 0 0 8.97156 0 20C0 31.0284 8.97156 40 20 40C31.0284 40 40 31.0284 40 20C40 8.97156 31.0284 0 20 0Z",
    fill: "#67833E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1366 15.7617L19.3032 26.5948C18.9781 26.9199 18.5515 27.0834 18.1249 27.0834C17.6982 27.0834 17.2716 26.9199 16.9466 26.5948L11.53 21.1783C10.8782 20.5267 10.8782 19.4733 11.53 18.8217C12.1816 18.1699 13.2347 18.1699 13.8866 18.8217L18.1249 23.06L27.78 13.4052C28.4316 12.7533 29.4847 12.7533 30.1366 13.4052C30.7881 14.0567 30.7881 15.1099 30.1366 15.7617Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconOffer);
export default __webpack_public_path__ + "static/media/tickIconOffer.beb93df6.svg";
export { ForwardRef as ReactComponent };